var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"banner-02"}},[_c('article',{staticClass:"banner"},[_c('div',{staticClass:"btn-action"},[(_vm.webstarsPanelUrl)?_c('a',{staticClass:"item",attrs:{"href":_vm.webstarsPanelUrl}},[_vm._v("\n                "+_vm._s(_vm.$t('home2021.banners.footer.more_info'))+"\n            ")]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }